module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/сurtains-188c629d3024eddf84daec091a90e4e5.svg";